import { useIsMobile } from 'src/shared/hooks/use-mobile'

import AuthBackgroundImage from '/src/features/auth/assets/auth.png'
import MobileAuthBackgroundImage from '/src/features/auth/assets/mobile-auth.png'

const AuthBackground = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className="flex w-full items-center justify-center">
        <div className="mt-[20px] w-[90%] max-w-[600px] overflow-hidden rounded-t-[60px] shadow-[0px_-2px_20px_0px_rgba(27,48,41,0.1)] xs:mt-[30px] xs:rounded-t-[80px] xs:shadow-[0px_-2px_30px_0px_rgba(27,48,41,0.1)]">
          <img src={MobileAuthBackgroundImage} alt="Mobile Auth Background" className="object-contain" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-[calc(100vh-128px)] w-full items-center justify-center">
      <img
        src={AuthBackgroundImage}
        alt="Auth Background"
        className="absolute bottom-[168px] right-20 object-contain"
        style={{
          minWidth: 1400,
          height: 900,
        }}
      />
    </div>
  )
}

export default AuthBackground
